import React, { useEffect, FC } from 'react';
import { setGlobal, useGlobal } from 'reactn';

import Typography from '@material-ui/core/Typography';

import AppRouter from './router/RouterComponent';
import Keycloak from 'keycloak-js';
import { SnackbarProvider } from 'notistack';
import KeycloakState from './auth/KeycloakState';
import { ThemeProvider, Icon, createStyles, makeStyles, Theme } from '@material-ui/core';
import { muiTheme } from './AppStyle';
import AddFooter from './components/AddFooter';

setGlobal({
    keycloakState: new KeycloakState(null, false, null),
    pinHeader: false,
});

const useStyles = makeStyles((_theme: Theme) =>
    createStyles({
        materialIcon: {
            position: 'relative',
            top: '4px',
            // Workaround to avoid having the text representation of an icon displayed while a font is loading
            "&:before": {
                content: '""',
            },
        },
    }),
);

const App: FC = () => {
    const [globalState, setGlobalState] = useGlobal();
    const classes = useStyles();

    useKeycloak(
        keycloakState => setGlobalState({ keycloakState }),
    );

    if (globalState.keycloakState.keycloak !== null && globalState.keycloakState.authenticated) {
        return (
            <ThemeProvider theme={muiTheme}>
                <AddFooter>
                    <SnackbarProvider>
                        <AppRouter />
                    </SnackbarProvider>
                </AddFooter>
            </ThemeProvider>
        );
    } else {
        var [statusIcon, statusMessage] = globalState.keycloakState.statusIconAndMessage;
        return (
            <ThemeProvider theme={muiTheme}>
                <Typography variant="h6" style={{ marginTop: "14px", marginLeft: "24px" }}>
                    <Icon className={classes.materialIcon}>{statusIcon}</Icon> {statusMessage}
                </Typography>
            </ThemeProvider>
        );
    }
};

const useKeycloak = (
    setKeycloakState: (keycloakState: KeycloakState) => void,
) => {
    useEffect(() => {
        const keycloak = Keycloak('/keycloak.json');
        setKeycloakState(new KeycloakState(null, false, ['lock', 'Authenticating...']));
        keycloak.init({ onLoad: 'login-required' })
            .then((authenticated: any) => {
                setKeycloakState(new KeycloakState(keycloak, authenticated, ['check', 'Authenticated']));
            })
            .catch((error) => {
                setKeycloakState(new KeycloakState(null, false, ['warning', `Authentication Error: ${error}`]));
            });
    }, []);
}

export default App;
